import { memo } from "react";
import RightImg from "./images/right-image.png";
import LeftImg from "./images/left-image.png";
import BatIcon from "./images/icons/bat.svg?react";
import "./HalloweenTheme.scss";

export const HalloweenTheme = memo(() => {
  return (
    <>
      <div className="leftDecorImg">
        <img src={LeftImg} alt="Left info bar image" />
      </div>
      <div className="leftBat">
        <BatIcon />
      </div>
      <div className="rightBats">
        <div className="batsIcons">
          <BatIcon />
          <BatIcon />
        </div>
      </div>
      <div className="rightDecorImg">
        <img src={RightImg} alt="Right info bar image" />
      </div>
    </>
  );
});
